import { render, staticRenderFns } from "./LoveMapSmallText.vue?vue&type=template&id=629c0ee4&scoped=true&"
import script from "./LoveMapSmallText.vue?vue&type=script&lang=js&"
export * from "./LoveMapSmallText.vue?vue&type=script&lang=js&"
import style0 from "./LoveMapSmallText.vue?vue&type=style&index=0&id=629c0ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629c0ee4",
  null
  
)

export default component.exports